import { Link } from "react-router-dom";
import { Phone, ClipboardList, MessageSquareText } from "lucide-react";
import { SITE } from "../config/site";

export function MobileActionBar() {
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-edge bg-obsidian/95 backdrop-blur-xl lg:hidden"
    >
      <a
        href={SITE.phoneHref}
        data-testid="mobile-bar-call-button"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-slate-200 transition-colors active:bg-elevated"
      >
        <Phone className="h-5 w-5 text-amber2" />
        <span className="text-[11px] font-bold uppercase tracking-wide">Call</span>
      </a>
      <Link
        to="/get-a-brake-quote"
        data-testid="mobile-bar-quote-button"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 bg-crimson text-white transition-colors active:bg-crimsondark"
      >
        <ClipboardList className="h-5 w-5" />
        <span className="text-[11px] font-bold uppercase tracking-wide">Brake Quote</span>
      </Link>
      <a
        href={SITE.smsHref}
        data-testid="mobile-bar-text-button"
        className="flex min-h-[56px] flex-col items-center justify-center gap-0.5 text-slate-200 transition-colors active:bg-elevated"
      >
        <MessageSquareText className="h-5 w-5 text-amber2" />
        <span className="text-[11px] font-bold uppercase tracking-wide">Text</span>
      </a>
    </div>
  );
}
